import React from "react";
import styled from 'styled-components';
import ClaroParagraph from '../../atoms/ClaroParagraph'
import ClaroPadding from '../../atoms/ClaroPadding'


/*
const ClaroCardItem = styled.div `
    padding: ${props => props.padding ? props.padding : "1rem"};
    display: ${props => props.display ? props.display : "flex"};
    width: 100%;
`
*/

const ClaroCard = styled.div`
    background-color: white;
    border-radius: 0.25rem;
    box-shadow: 0 0px 35px -1px rgba(0, 0, 0, 0.20);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    width: 100%;
    padding: 1rem;
    margin: 14px;
    font-family: Nunito;
    font-size: 18px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #000000;
`




const ClaroMenuItemBlock = ({padding, children, image:{data:{display, align, src, alt, height, width, base64}}}) => {

    let imgData = base64 ? base64 : src;

    return(


            <ClaroCard>
                <ClaroParagraph id="container-card" {...align}>
                    <ClaroPadding padding={padding} display={display}>
                    {
                    imgData ? (
                        <img src={imgData} alt={alt} height={height} width={width} />
                    )
                    :
                    ""
                    }
                    </ClaroPadding>
                    {children}
                </ClaroParagraph>
            </ClaroCard>
    )
}


export default ClaroMenuItemBlock;